import React, { Fragment } from "react";
import styles from "./section_title.module.scss";

const SectionTitle = (props) => {
  return (
    <Fragment>
      <div className={styles.title_area}>
        <h2 className={styles.shadow_text}>{props.shadow_text}</h2>
        <h3 className={styles.title_text}>
          <span>{props.title}</span>
          <span className={`${styles.title_arc} arc`}></span>
        </h3>
      </div>
      <div className={styles.sub_text}>{props.children}</div>
    </Fragment>
  );
};

export default SectionTitle;
